import classNames from 'classnames';
import React from 'react';

const COMPONENT_KIND_CLASS_MAP = {
    delete: "tds-btn--delete",
    ghost: "tds-btn--ghost-neutral",
    "ghost-delete": "tds-btn--ghost-delete",
    "ghost-interaction": "tds-btn--ghost-interaction",
    "inline-text": "tds-btn--inline-text",
    neutral: "tds-btn--neutral",
    pill: "tds-btn--pill",
    primary: "tds-btn--interaction",
    "primary-page-header": "tds-btn--primary-page-header",
    secondary: "tds-btn--outline-neutral",
    "secondary-delete": "tds-btn--outline-delete",
    "secondary-interaction": "tds-btn--outline-interaction",
    "secondary-page-header": "tds-btn--secondary-page-header",
};
const COMPONENT_SIZE_CLASS_MAP = {
    lg: "tds-btn--lg",
    md: "",
    sm: "tds-btn--sm",
    xl: "tds-btn--xl",
    xs: "tds-btn--xs",
};
const enhanceElementWithClassName = (element, className) => {
    if (!element)
        return null;
    if (React.isValidElement(element)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return React.cloneElement(element, {
            className: classNames(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            element.props.className, className),
        });
    }
    if (typeof element === "string" && element.trim()) {
        return React.createElement("span", { className }, element);
    }
    return null;
};

export { COMPONENT_KIND_CLASS_MAP, COMPONENT_SIZE_CLASS_MAP, enhanceElementWithClassName };
//# sourceMappingURL=buttonLinkShared.js.map
